import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 17h8c1.105 0 2 -.895 2 -2v-.5c0 -.276 .224 -.5 .5 -.5s.5 -.224 .5 -.5v-3c0 -.276 -.224 -.5 -.5 -.5s-.5 -.224 -.5 -.5v-.5c0 -1.105 -.895 -2 -2 -2h-11c-1.105 0 -2 .895 -2 2v3","key":"svg-0"}],["path",{"d":"M5 16v3","key":"svg-1"}],["path",{"d":"M5 22v.01","key":"svg-2"}]]

const IconBatteryExclamation = createReactComponent('outline', 'battery-exclamation', 'BatteryExclamation', __iconNode);

export default IconBatteryExclamation;